/* Human Pro PDP - hero behaviour, part 1: gallery, pack selection, price sync.

   Externalised from snippets/hpx-hero-js.liquid on 23 Aug 2026 so it is cached once
   and reused across every PDP rather than re-sent inside each page's HTML.

   ⚠️ BACKSLASHES: keep them single. A GraphQL block string passes them through
   literally, and a doubled one silently turned the sibling file into a syntax error.

   ⚠️ NO LIQUID IN THIS FILE. Being pure JS with no Liquid interpolation is what makes
   it cacheable across every PDP - snippets/hpx-hero-js.liquid documents that. Every
   translated string therefore arrives at runtime through window.HPX_I18N, and every
   per-store number through window.HPX_FACTS; snippets/hpx-i18n-data prints both
   inline BEFORE this file loads.

   galleryImages comes from window.HPX_GALLERY, which hpx-hero-gallery-data prints
   inline BEFORE this file loads. Liquid is the source of truth; the DOM scrape below
   is a fallback only, so a missing parameter degrades to a working gallery. */

/* ---- i18n -------------------------------------------------------------------
   hpxT(key, vars, fallback) looks the key up in window.HPX_I18N and substitutes the
   {{ token }} placeholders, which arrive as literal text inside the translated value.
   hpxPlural picks <base>_one or <base>_other on a count.

   BOTH DEGRADE TO THE ENGLISH FALLBACK. A missing HPX_I18N, a missing key or an empty
   value renders the literal this file used to hardcode, so a stale cached copy of this
   asset - or a locale nobody has translated yet - never blanks the page.

   Assigned on window and guarded, because hpx-hero2.js defines the same pair for the
   case where it loads without this file: whichever runs first wins, the other reuses
   it, and there is no redeclaration. */
window.hpxT = window.hpxT || function (key, vars, fallback) {
  var dict = window.HPX_I18N || {};
  var s = (typeof dict[key] === 'string' && dict[key] !== '') ? dict[key] : fallback;
  if (typeof s !== 'string') return '';
  if (!vars) return s;
  return s.replace(/\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g, function (m, name) {
    return Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : m;
  });
};
window.hpxPlural = window.hpxPlural || function (base, count, vars, fallbackOne, fallbackOther) {
  var one = Number(count) === 1;
  return window.hpxT(base + (one ? '_one' : '_other'), vars, one ? fallbackOne : fallbackOther);
};

/* THE DECIMAL FORMATTER. Mirrors snippets/hpx-price - two places, comma separator -
   so a figure this file computes at runtime is written the same way as the one
   Liquid rendered for the first paint.

   ⚠️ EVERY RUNTIME NUMBER GOES THROUGH IT. The per-unit price did not, and printed
   toFixed(2) raw: the German pack cards read "0.53 € pro Kapsel" under a price that
   read "63,99 €". A bare toFixed(2) anywhere in this file is that bug waiting to
   come back. The bare prices in the data-* attributes are already comma-formatted
   by hpx-price, so they never pass through here - only figures divided at runtime
   do (per unit, per day, the Klarna third). */
window.hpxAmount = window.hpxAmount || function (num) {
  var n = Number(num);
  if (!isFinite(n)) n = 0;
  return n.toFixed(2).replace('.', ',');
};

/* A bare money amount. German renders "12,34 €" and Dutch "€ 12,34", so the symbol has
   to live inside the translated string rather than be concatenated in front of it.
   price_amount IS in the HPX_I18N contract - snippets/hpx-i18n-data prints it - and
   sections/hpx-hero renders the same key for the first paint, so Liquid and this file
   put the symbol on the same side. The fallback below only covers a stale cached copy
   of that snippet. */
function hpxMoney(amount) {
  return hpxT('price_amount', { amount: amount }, '€' + amount);
}

/* ============================================================================
   ⚠️⚠️ §87 - THERE IS NO MONEY ARITHMETIC IN THIS FILE ANY MORE.
   ============================================================================

   Everything above formats for ONE currency. hpxAmount hardcodes a comma decimal
   separator; hpxMoney's fallback concatenates a literal '€'; the locale keys they
   reach carry a euro sign in all three languages. None of that survives contact with
   a store selling in eight presentment currencies - and this one does: CZK DKK EUR
   GBP HUF PLN RON SEK.

   Worse than the symbol was the parsing. The old code read its own formatted output
   back out of a data attribute:

       var priceNum = parseFloat(price.replace(',', '.'));     // "23.900,00"
                                                               // -> "23.900.00" -> 23.9

   Any amount that carried a thousands separator came back 1000x too small, so every
   figure derived from it - per capsule, per day, the Klarna third, the free-shipping
   comparison - was silently wrong the instant a shopper clicked a pack. On the
   Hungarian PDP "199,17 Ft per capsule" became "€0,20".

   ➜ THE RULE NOW: Liquid composes every money string, in the presentment currency,
     for BOTH tabs, into data-<tab>-<field>-txt attributes on the pack card. This file
     COPIES them. It never parses a price, never divides one, and never builds a
     symbol.

   ⚠️ Do not reintroduce a formatter here "just for one number". The number you want
     is almost certainly already rendered on the card - see hpx-pack-card, which emits
     price / compare / save / percap / perday / klarna for one-time and subscribe. If
     it genuinely is not, add it THERE, where the currency is known.

   hpxAmount and hpxMoney are kept only for the non-money strings that still use them
   and for base-currency fallbacks. Do not aim new price code at them.
   ========================================================================= */
function hpxPackText(card, prefix) {
  function at(name) { return card.getAttribute('data-' + prefix + '-' + name + '-txt') || ''; }
  return {
    price:   at('price'),
    compare: at('compare'),
    save:    at('save'),
    percap:  at('percap'),
    perday:  at('perday'),
    klarna:  at('klarna'),
    cents:   Number(card.getAttribute('data-' + prefix + '-cents') || 0)
  };
}

var galleryImages = (function () {
  if (window.HPX_GALLERY && window.HPX_GALLERY.length) return window.HPX_GALLERY;
  var out = [];
  var nodes = document.querySelectorAll('.gallery-thumbs .gallery-thumb img');
  for (var i = 0; i < nodes.length; i++) {
    var s = nodes[i].getAttribute('src');
    if (s) out.push(s);
  }
  if (!out.length) {
    var mi = document.getElementById('mainImage');
    if (mi && mi.getAttribute('src')) out.push(mi.getAttribute('src'));
  }
  return out;
})();

var currentImageIndex = 0;

function updateGallery(index) {
  var prevIndex = currentImageIndex;
  currentImageIndex = index;
  var mainImg = document.getElementById('mainImage');
  if (!mainImg || !galleryImages[index]) return;
  var direction = index > prevIndex ? 1 : -1;

  var clone = mainImg.cloneNode(true);
  clone.id = '';
  clone.style.position = 'absolute';
  clone.style.top = '0';
  clone.style.left = '0';
  clone.style.width = '100%';
  clone.style.zIndex = '1';
  clone.style.transition = 'transform 0.3s cubic-bezier(0.4,0,0.2,1)';
  mainImg.parentElement.appendChild(clone);

  mainImg.style.transition = 'none';
  mainImg.style.transform = 'translateX(' + (100 * direction) + '%)';
  // Responsive variants only exist for the initial hero render and were MEC-specific.
  // Drop them on navigation rather than forcing MEC's srcset onto another product.
  mainImg.removeAttribute('srcset');
  mainImg.removeAttribute('sizes');
  mainImg.src = galleryImages[index];
  mainImg.style.zIndex = '2';
  mainImg.offsetHeight;

  clone.style.transform = 'translateX(' + (-100 * direction) + '%)';
  mainImg.style.transition = 'transform 0.3s cubic-bezier(0.22,1,0.36,1)';
  mainImg.style.transform = 'translateX(0)';

  setTimeout(function () { clone.remove(); mainImg.style.zIndex = ''; }, 350);
  document.querySelectorAll('.gallery-thumb').forEach(function (t, i) {
    t.classList.toggle('active', i === index);
  });
  setTimeout(function () {
    var gp = document.getElementById('galleryPrev');
    var gn = document.getElementById('galleryNext');
    if (gp) gp.style.display = index === 0 ? 'none' : 'flex';
    if (gn) gn.style.display = index === galleryImages.length - 1 ? 'none' : 'flex';
  }, 50);
  var mobileImg = document.getElementById('mobileMainImage');
  if (mobileImg) {
    mobileImg.removeAttribute('srcset');
    mobileImg.removeAttribute('sizes');
    mobileImg.src = galleryImages[index];
    var mp = document.getElementById('mobileGalleryPrev');
    var mn = document.getElementById('mobileGalleryNext');
    if (mp) mp.style.display = index === 0 ? 'none' : 'flex';
    if (mn) mn.style.display = index === galleryImages.length - 1 ? 'none' : 'flex';
  }
}

function navigateGallery(dir) {
  var newIndex = currentImageIndex + dir;
  if (newIndex >= 0 && newIndex < galleryImages.length) updateGallery(newIndex);
}

// Thumbnail click. Resolved by the thumbnail's position in the list rather than by
// matching its URL, so it cannot break if the array and the markup differ.
function switchImage(thumb, src) {
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumbs .gallery-thumb'));
  var index = thumbs.indexOf(thumb);
  if (index < 0 && src) index = galleryImages.indexOf(src);
  if (index >= 0) updateGallery(index);
}

// Mobile USP carousel - rotate every 4 seconds
(function () {
  var track = document.getElementById('mobileUspTrack');
  if (!track) return;
  var slides = track.querySelectorAll('.mobile-usp-slide');
  if (slides.length < 2) return;
  var current = 0;
  setInterval(function () {
    current = (current + 1) % slides.length;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
  }, 4000);
})();

// SMOOTH SWIPE GESTURE for mobile gallery - image follows finger
(function () {
  var mobileHero = document.querySelector('.mobile-hero-image .gallery-main');
  if (!mobileHero) return;
  var mImg = document.getElementById('mobileMainImage');
  if (!mImg) return;

  var startX = 0, currentX = 0, isDragging = false, isHorizontal = null;
  var startY = 0;

  var peekImg = document.createElement('img');
  peekImg.style.cssText = 'position:absolute;top:0;width:100%;height:100%;object-fit:cover;z-index:1;display:none;pointer-events:none;';
  mobileHero.style.position = 'relative';
  mobileHero.style.overflow = 'hidden';
  mobileHero.appendChild(peekImg);

  mobileHero.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true;
    isHorizontal = null;
    mImg.style.transition = 'none';
    peekImg.style.transition = 'none';
  }, { passive: true });

  mobileHero.addEventListener('touchmove', function (e) {
    if (!isDragging) return;
    var touchX = e.touches[0].clientX;
    var touchY = e.touches[0].clientY;
    var diffX = touchX - startX;
    var diffY = touchY - startY;

    if (isHorizontal === null && (Math.abs(diffX) > 8 || Math.abs(diffY) > 8)) {
      isHorizontal = Math.abs(diffX) > Math.abs(diffY);
    }
    if (!isHorizontal) return;

    e.preventDefault();
    currentX = diffX;
    var w = mobileHero.offsetWidth;

    mImg.style.transform = 'translateX(' + diffX + 'px)';
    mImg.style.zIndex = '2';

    var nextIdx = diffX < 0 ? currentImageIndex + 1 : currentImageIndex - 1;
    if (nextIdx >= 0 && nextIdx < galleryImages.length) {
      peekImg.src = galleryImages[nextIdx];
      peekImg.style.display = 'block';
      peekImg.style.left = '';
      peekImg.style.right = '';
      if (diffX < 0) {
        peekImg.style.transform = 'translateX(' + (w + diffX) + 'px)';
      } else {
        peekImg.style.transform = 'translateX(' + (-w + diffX) + 'px)';
      }
    } else {
      peekImg.style.display = 'none';
      mImg.style.transform = 'translateX(' + (diffX * 0.3) + 'px)';
    }
  }, { passive: false });

  mobileHero.addEventListener('touchend', function () {
    if (!isDragging) return;
    isDragging = false;
    var w = mobileHero.offsetWidth;
    var threshold = w * 0.2;

    mImg.style.transition = 'transform 0.3s cubic-bezier(0.22,1,0.36,1)';
    peekImg.style.transition = 'transform 0.3s cubic-bezier(0.22,1,0.36,1)';

    if (isHorizontal && Math.abs(currentX) > threshold) {
      var dir = currentX < 0 ? 1 : -1;
      var nextIdx = currentImageIndex + dir;
      if (nextIdx >= 0 && nextIdx < galleryImages.length) {
        mImg.style.transform = 'translateX(' + (-dir * w) + 'px)';
        peekImg.style.transform = 'translateX(0)';
        setTimeout(function () {
          mImg.style.transition = 'none';
          mImg.removeAttribute('srcset');
          mImg.removeAttribute('sizes');
          mImg.src = galleryImages[nextIdx];
          mImg.style.transform = 'translateX(0)';
          mImg.style.zIndex = '';
          peekImg.style.display = 'none';
          peekImg.style.transform = '';
          currentImageIndex = nextIdx;
          var mp = document.getElementById('mobileGalleryPrev');
          var mn = document.getElementById('mobileGalleryNext');
          if (mp) mp.style.display = nextIdx === 0 ? 'none' : 'flex';
          if (mn) mn.style.display = nextIdx === galleryImages.length - 1 ? 'none' : 'flex';
          var dImg = document.getElementById('mainImage');
          if (dImg) dImg.src = galleryImages[nextIdx];
          document.querySelectorAll('.gallery-thumb').forEach(function (t, i) { t.classList.toggle('active', i === nextIdx); });
          var gp2 = document.getElementById('galleryPrev');
          var gn2 = document.getElementById('galleryNext');
          if (gp2) gp2.style.display = nextIdx === 0 ? 'none' : 'flex';
          if (gn2) gn2.style.display = nextIdx === galleryImages.length - 1 ? 'none' : 'flex';
        }, 320);
        currentX = 0;
        return;
      }
    }
    mImg.style.transform = 'translateX(0)';
    mImg.style.zIndex = '';
    peekImg.style.display = 'none';
    peekImg.style.transform = '';
    currentX = 0;
  }, { passive: true });
})();

// LIGHTBOX - click gallery image to enlarge
(function () {
  var lb = document.createElement('div');
  lb.id = 'imageLightbox';
  lb.style.cssText = 'display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;background:rgba(0,0,0,0.92);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);align-items:center;justify-content:center;cursor:zoom-out;';
  var lbImg = document.createElement('img');
  lbImg.style.cssText = 'max-width:94vw;max-height:90vh;object-fit:contain;border-radius:8px;';
  var lbClose = document.createElement('button');
  lbClose.innerHTML = '&times;';
  lbClose.style.cssText = 'position:absolute;top:16px;right:20px;background:none;border:none;color:white;font-size:36px;cursor:pointer;z-index:10000;width:44px;height:44px;display:flex;align-items:center;justify-content:center;';
  var lbPrev = document.createElement('button');
  lbPrev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="28" height="28"><polyline points="15 18 9 12 15 6"/></svg>';
  lbPrev.style.cssText = 'position:absolute;left:12px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.15);border:none;color:white;cursor:pointer;z-index:10000;width:48px;height:48px;display:flex;align-items:center;justify-content:center;border-radius:50%;backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);';
  var lbNext = document.createElement('button');
  lbNext.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="28" height="28"><polyline points="9 18 15 12 9 6"/></svg>';
  lbNext.style.cssText = 'position:absolute;right:12px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.15);border:none;color:white;cursor:pointer;z-index:10000;width:48px;height:48px;display:flex;align-items:center;justify-content:center;border-radius:50%;backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);';
  lb.appendChild(lbClose);
  lb.appendChild(lbPrev);
  lb.appendChild(lbNext);
  lb.appendChild(lbImg);
  document.body.appendChild(lb);

  function updateLbArrows() {
    lbPrev.style.display = currentImageIndex > 0 ? 'flex' : 'none';
    lbNext.style.display = currentImageIndex < galleryImages.length - 1 ? 'flex' : 'none';
  }

  lbPrev.addEventListener('click', function (e) {
    e.stopPropagation();
    if (currentImageIndex > 0) {
      navigateGallery(-1);
      lbImg.src = galleryImages[currentImageIndex];
      updateLbArrows();
    }
  });
  lbNext.addEventListener('click', function (e) {
    e.stopPropagation();
    if (currentImageIndex < galleryImages.length - 1) {
      navigateGallery(1);
      lbImg.src = galleryImages[currentImageIndex];
      updateLbArrows();
    }
  });

  function closeLightbox() { lb.style.display = 'none'; document.body.style.overflow = ''; }
  lb.addEventListener('click', closeLightbox);
  lbClose.addEventListener('click', function (e) { e.stopPropagation(); closeLightbox(); });

  var lbStartX = 0;
  lb.addEventListener('touchstart', function (e) { lbStartX = e.changedTouches[0].screenX; }, { passive: true });
  lb.addEventListener('touchend', function (e) {
    var diff = lbStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) navigateGallery(1); else navigateGallery(-1);
      lbImg.src = galleryImages[currentImageIndex];
      updateLbArrows();
    }
  }, { passive: true });

  var mImg = document.getElementById('mobileMainImage');
  if (mImg) {
    mImg.style.cursor = 'zoom-in';
    mImg.addEventListener('click', function () {
      lbImg.src = galleryImages[currentImageIndex];
      lb.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      updateLbArrows();
    });
  }
  var dImg = document.getElementById('mainImage');
  if (dImg) {
    dImg.style.cursor = 'zoom-in';
    dImg.addEventListener('click', function () {
      lbImg.src = galleryImages[currentImageIndex];
      lb.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      updateLbArrows();
    });
  }
})();

(function () {
  var gp = document.getElementById('galleryPrev');
  var gn = document.getElementById('galleryNext');
  if (gp) gp.addEventListener('click', function () {
    if (currentImageIndex > 0) updateGallery(currentImageIndex - 1);
  });
  if (gn) gn.addEventListener('click', function () {
    if (currentImageIndex < galleryImages.length - 1) updateGallery(currentImageIndex + 1);
  });
  if (gp) gp.style.display = 'none';
  if (gn) gn.style.display = galleryImages.length > 1 ? 'flex' : 'none';
})();

/* Unit of sale and pack name, read from the data attributes hpx-i18n-data prints -
   data-unit-one / data-unit-other on #packOptions, data-pack-label on each card -
   rather than rebuilt from literals here.

   ⚠️ THESE USED TO SCRAPE THE RENDERED TEXT AND THAT IS WHY THEY CHANGED.
   hpxUnitWord stripped a leading /^[\d\s.,]+/ off "120 capsules", which assumes the
   number comes first and that the separator is an ordinary space - a narrow no-break
   space, or a language that puts the unit first, left the digits in place.
   hpxPackLabel stripped a trailing [\s–—-]+ off "1 Month Supply - " and otherwise
   concatenated 'Month' + (months > 1 ? 's' : '') + ' Supply', which is English
   pluralisation. Both then fell back to an English literal WITH NOTHING IN THE
   CONSOLE. Attributes cannot fail that way; the i18n fallbacks below only run when
   the attribute is missing entirely. */
function hpxUnitWord(count) {
  var opts = document.getElementById('packOptions');
  var word = '';
  if (opts) {
    word = (Number(count) === 1)
      ? (opts.getAttribute('data-unit-one') || '')
      : (opts.getAttribute('data-unit-other') || '');
  }
  if (word) return word;
  return (Number(count) === 1)
    ? hpxT('unit_capsule', null, 'capsule')
    : hpxT('unit_capsules', null, 'capsules');
}
function hpxPackLabel(card, months) {
  var w = card ? (card.getAttribute('data-pack-label') || '') : '';
  if (w) return w;
  return hpxPlural('supply', months, { count: months }, months + ' Month Supply', months + ' Months Supply');
}

// Purchase tab switching
var currentTab = 'onetime';
function switchPurchaseTab(tab) {
  currentTab = tab;
  document.querySelectorAll('.purchase-tab').forEach(function (t) { t.classList.remove('active'); });
  var tabBtn = document.getElementById('tab-' + tab);
  if (tabBtn) tabBtn.classList.add('active');
  var switchLink = document.getElementById('switchToSub');
  if (switchLink) switchLink.style.display = tab === 'subscribe' ? 'none' : '';

  document.querySelectorAll('.pack-card').forEach(function (card) {
    var prefix = tab === 'subscribe' ? 'sub' : 'onetime';
    var txt = hpxPackText(card, prefix);
    if (!txt.price) return;
    var capsules = parseInt(card.dataset.capsules);
    /* ⚠️ EACH OF THESE FOUR ELEMENTS HOLDS A WHOLE TRANSLATED SENTENCE, not a bare
       number, and hpx-pack-card renders it that way for two reasons: the currency
       symbol's side is a property of the language, and a <span> handed to a `| t`
       argument comes back ESCAPED - the German save line printed its own markup as
       visible text. So compose the locale key here and write the OUTER element,
       exactly as .save-badge is handled in updateMainPrice below. Do not put an
       inner value span back for the JS to aim at. */
    var pv = card.querySelector('.pack-price');
    if (pv) pv.textContent = txt.price;
    var sv = card.querySelector('.pack-save');
    if (sv) sv.textContent = txt.save;
    var pc = card.querySelector('.pack-per-capsule');
    if (pc && capsules > 0 && txt.percap) pc.textContent = txt.percap;
    var pu = card.querySelector('.pack-per-unit');
    var puTxt = card.getAttribute('data-' + (tab === 'subscribe' ? 'sub' : 'onetime') + '-unit-txt') || '';
    if (pu && puTxt) pu.textContent = puTxt;
    var pdo = card.querySelector('.pack-per-dose');
    var pdoTxt = card.getAttribute('data-' + (tab === 'subscribe' ? 'sub' : 'onetime') + '-dose-txt') || '';
    if (pdo && pdoTxt) pdo.textContent = pdoTxt;
    var compareEl = card.querySelector('.pack-compare-price');
    if (compareEl) compareEl.textContent = txt.compare;
    var freqEl = card.querySelector('.pack-frequency');
    if (freqEl) freqEl.style.display = tab === 'subscribe' ? 'block' : 'none';
  });
  var selectedPack = document.querySelector('.pack-card.selected');
  if (selectedPack) updateMainPrice(selectedPack);
}

function selectPack(el, packNum) {
  document.querySelectorAll('.pack-card').forEach(function (p) { p.classList.remove('selected'); });
  el.classList.add('selected');
  updateMainPrice(el);

  var thumbs = el.querySelectorAll('.pack-thumb');
  thumbs.forEach(function (thumb, i) {
    setTimeout(function () {
      thumb.style.transition = 'transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)';
      thumb.style.transform = 'translateY(-6px)';
      setTimeout(function () { thumb.style.transform = 'translateY(0)'; }, 200);
    }, i * 80);
  });
}

function updateMainPrice(card) {
  var prefix = currentTab === 'subscribe' ? 'sub' : 'onetime';
  var txt = hpxPackText(card, prefix);
  if (!txt.price) return;
  var capsules = parseInt(card.dataset.capsules);

  var dp = document.getElementById('displayPrice');
  if (dp) dp.textContent = txt.price;
  var dc = document.getElementById('displayCompare');
  if (dc) dc.textContent = txt.compare;
  // The whole badge is rewritten, not just an inner span: "Save €12" is one string
  // and the symbol sits inside it, before the amount in NL and after it in DE.
  var saveBadge = document.querySelector('.save-badge');
  if (saveBadge) saveBadge.textContent = txt.save;
  var atcPrice = document.getElementById('atcPrice');
  if (atcPrice) atcPrice.textContent = txt.price;
  var atcCompare = document.getElementById('atcCompare');
  if (atcCompare) atcCompare.textContent = txt.compare;
  var compareAtcP = document.getElementById('compareAtcPrice');
  if (compareAtcP) compareAtcP.textContent = txt.price;
  var compareAtcC = document.getElementById('compareAtcCompare');
  if (compareAtcC) compareAtcC.textContent = txt.compare;

  // ⚠️ LOAD-BEARING AND DELIBERATELY UNCHANGED: which pack this is comes from the
  // card's POSITION among #packOptions children, documented in hpx-pack-card.
  var months = 1;
  if (card.classList.contains('pack-card-best')) { months = 3; }
  else if (card.parentElement && Array.prototype.indexOf.call(card.parentElement.children, card) === 1) { months = 2; }

  var unitWord = hpxUnitWord(capsules);
  var baseLabel = hpxPackLabel(card, months);
  var cadence = hpxPlural('cadence', months, { count: months }, 'Every month', 'Every ' + months + ' months');

  var compareAtcVariant = document.getElementById('compareAtcVariant');
  if (compareAtcVariant) {
    if (capsules > 0) {
      compareAtcVariant.textContent = currentTab === 'subscribe'
        ? hpxT('pack_summary_with_cadence', { count: capsules, unit: unitWord, label: baseLabel, cadence: cadence }, capsules + ' ' + unitWord + ' · ' + baseLabel + ' · ' + cadence)
        : hpxT('pack_summary', { count: capsules, unit: unitWord, label: baseLabel }, capsules + ' ' + unitWord + ' · ' + baseLabel);
    } else {
      compareAtcVariant.textContent = currentTab === 'subscribe'
        ? hpxT('pack_with_cadence', { label: baseLabel, cadence: cadence }, baseLabel + ' · ' + cadence)
        : baseLabel;
    }
  }
  // .pack-compare-price is a whole translated string too - see switchPurchaseTab.
  card.querySelectorAll('.pack-compare-price').forEach(function (el) { el.textContent = txt.compare; });

  // Social proof. These percentages are MEC's own research figures, keyed to MEC's
  // capsule counts. For any other product the line stays exactly as rendered from
  // hpx.social_proof rather than being overwritten with MEC's numbers.
  // The pack name is no longer part of this table: it comes from the pack card, so
  // it is whatever that product calls the pack, in whatever language.
  var socialProof = document.getElementById('socialProofText');
  if (socialProof) {
    var packData = {
      '120': { pct: '61', euro: '12,79' },
      '240': { pct: '79', euro: '16,64' },
      '360': { pct: '91', euro: '21,12' }
    };
    // ⚠️ §87 - pd.euro is a STATIC EUR RESEARCH FIGURE, not a converted price. It is
    // not a price at all, so there is nothing to convert it from; printed under a
    // Swedish krona sign it would simply be false. Outside the shop currency the
    // percentage sentence still stands on its own, so the saving clause is dropped
    // rather than restated in a currency it was never measured in.
    var pd = (window.HPX_MONEY && window.HPX_MONEY.isBase === false) ? null : packData[String(capsules)];
    if (pd) {
      // Rebuilt as nodes rather than one innerHTML string: the saving is its own
      // translated string because the currency symbol lives inside it.
      var spm = document.createElement('span');
      spm.className = 'save-per-month';
      spm.textContent = hpxT('social_proof_saving', { amount: pd.euro }, '(save €' + pd.euro + ' per month)');
      socialProof.textContent = hpxT('social_proof_subscription', { percent: pd.pct, pack: baseLabel }, pd.pct + '% of ' + baseLabel + ' customers saved money with a subscription') + ' ';
      socialProof.appendChild(spm);
    }
    var switchLink2 = document.getElementById('switchToSub');
    if (switchLink2) switchLink2.style.display = currentTab === 'subscribe' ? 'none' : '';
  }

  var stickyAtcP = document.getElementById('stickyAtcPrice');
  var stickyAtcC = document.getElementById('stickyAtcCompare');
  if (stickyAtcP) stickyAtcP.textContent = txt.price;
  if (stickyAtcC) stickyAtcC.textContent = txt.compare;

  var stickyPackName = document.getElementById('stickyPackName');
  if (stickyPackName) {
    if (currentTab === 'subscribe') {
      var cadenceLower = hpxPlural('cadence_lower', months, { count: months }, 'every month', 'every ' + months + ' months');
      stickyPackName.textContent = hpxT('pack_with_cadence', { label: baseLabel, cadence: cadenceLower }, baseLabel + ', ' + cadenceLower);
    } else {
      stickyPackName.textContent = baseLabel;
    }
  }
  var stickyPackPerday = document.getElementById('stickyPackPerday');
  if (stickyPackPerday) {
    // §87: the capsules/4 vs data-days rule now lives in hpx-pack-card, which knows
    // the currency and composes the whole string. This only copies it.
    if (txt.perday) stickyPackPerday.textContent = txt.perday;
  }
  document.querySelectorAll('.sticky-pack-option').forEach(function (opt) {
    var optPack = parseInt(opt.getAttribute('data-pack-num'), 10);
    opt.classList.toggle('is-active', optPack === months);
    // Both variants of every one of these strings are rendered by Liquid into
    // data-onetime / data-subscribe, so there is nothing to translate here.
    ['.opt-name', '.opt-discount', '.opt-perday', '.opt-compare', '.opt-price'].forEach(function (sel) {
      var el = opt.querySelector(sel);
      if (!el) return;
      var val = currentTab === 'subscribe' ? el.getAttribute('data-subscribe') : el.getAttribute('data-onetime');
      if (val) el.textContent = val;
    });
  });

  var shipB = document.getElementById('pdpShipBadge');
  var giftB = document.getElementById('pdpSprayBadge');
  // The free-shipping threshold is per destination country - 40 in NL, 70 elsewhere -
  // so it cannot be a literal in a file that is cached across every visitor.
  // hpx-i18n-data resolves it and prints it as window.HPX_FACTS.freeShippingThreshold.
  // ⚠️ §87 - IN PRESENTMENT CENTS, BOTH SIDES. This used to compare a major-unit
  // price against a bare EUR integer, so in SEK or HUF every pack cleared it and the
  // badge promised free shipping on a 1-pack. hpx-i18n-data now resolves the
  // threshold by CURRENCY and emits it in cents as freeShippingThresholdCents.
  var freeShipFrom = (window.HPX_FACTS && window.HPX_FACTS.freeShippingThresholdCents > 0)
    ? Number(window.HPX_FACTS.freeShippingThresholdCents)
    : 0;
  if (shipB) {
    if (freeShipFrom > 0 && txt.cents >= freeShipFrom) {
      shipB.textContent = hpxT('free_shipping_unlocked', null, '🚚 Free shipping unlocked');
      shipB.style.color = '#1a7a2e';
    } else {
      shipB.textContent = hpxT('free_shipping_locked', null, '🔒 Free shipping locked');
      shipB.style.color = 'var(--color-text-dim)';
    }
  }
  if (giftB) {
    /* Gift is earned on the 3-pack, whichever product this is. The name comes from
       data-gift-name, printed by sections/hpx-hero from the hpx.gift_name metafield.

       ⚠️ data-gift-name CARRIES THE GIFT'S NAME AND NOTHING ELSE - "Lion's Mane Focus
       Spray", never "Free Focus Spray locked". The "… locked" wording is added right
       here from gift_locked / gift_unlocked, so a complete sentence in the attribute
       is printed twice: the German badge read "🔒 Gratis Focus Spray noch gesperrt
       noch nicht freigeschaltet". hpx.gift_badge is that complete sentence and must
       not be fed to this attribute.

       ⚠️ IT USED TO BE SCRAPED OFF THE RENDERED BADGE with
       .replace(/^[^A-Za-z]+/, '').replace(/ locked$/, ''). [^A-Za-z] eats leading
       non-ASCII letters, so a German "Übungsspray" lost its Ü, and / locked$/ is an
       English suffix: once the badge was German the strip matched nothing, the code
       appended its own " locked" on top of the translated one, and the badge read the
       phrase twice. Silently, with nothing in the console. */
    var giftName = giftB.getAttribute('data-gift-name') || hpxT('gift_fallback_name', null, 'gift');
    if (card.classList.contains('pack-card-best')) {
      giftB.textContent = hpxT('gift_unlocked', { gift: giftName }, '👅 ' + giftName + ' unlocked');
      giftB.style.color = '#1a7a2e';
    } else {
      giftB.textContent = hpxT('gift_locked', { gift: giftName }, '🔒 ' + giftName + ' locked');
      giftB.style.color = 'var(--color-text-dim)';
    }
  }

  /* ⚠️ #klarnaInstalment IS THE WHOLE SENTENCE, NOT THE NUMBER INSIDE IT.

     The id used to sit on a <span> around the amount, and sections/hpx-hero handed
     that span to hpx.pdp.klarna_instalments as its `amount` argument. `t` escapes
     what it interpolates, so the line printed its own markup as visible text. The
     element now wraps the finished sentence and this is the only place that writes
     it - the same shape as the save badge and the pack cards. klarna_instalments is
     in the HPX_I18N contract; the fallback below only covers a stale cached copy of
     hpx-i18n-data. */
  var klarnaEl = document.getElementById('klarnaInstalment');
  if (klarnaEl) {
    // §87: composed in hpx-pack-card, in the presentment currency. Copied here.
    if (txt.klarna) klarnaEl.textContent = txt.klarna;
  }

  var hpxVid = document.getElementById('hpxVariantId');
  if (hpxVid && card.dataset.variantId) hpxVid.value = card.dataset.variantId;
}

function changeQty(delta) {
  var el = document.getElementById('qtyValue');
  if (!el) return;
  var val = parseInt(el.textContent) + delta;
  if (val < 1) val = 1;
  if (val > 10) val = 10;
  el.textContent = val;
}

function scrollIngredients(dir) {
  var el = document.getElementById('ingredientImages');
  if (!el) return;
  if (dir === 1) { el.scrollTo({ left: el.scrollWidth, behavior: 'smooth' }); }
  else { el.scrollTo({ left: 0, behavior: 'smooth' }); }
  setTimeout(updateIngredientArrows, 400);
}
function updateIngredientArrows() {
  var el = document.getElementById('ingredientImages');
  var leftBtn = document.querySelector('.ingredient-scroll-left');
  var rightBtn = document.querySelector('.ingredient-scroll-right');
  if (!el || !leftBtn || !rightBtn) return;
  leftBtn.style.display = el.scrollLeft > 10 ? 'flex' : 'none';
  rightBtn.style.display = (el.scrollLeft + el.clientWidth) < (el.scrollWidth - 10) ? 'flex' : 'none';
}
document.addEventListener('DOMContentLoaded', function () {
  var el = document.getElementById('ingredientImages');
  if (el) el.addEventListener('scroll', updateIngredientArrows);
});

function scrollIngredientsMobile(dir) {
  var el = document.getElementById('ingredientImagesMobile');
  if (!el) return;
  if (dir === 1) { el.scrollTo({ left: el.scrollWidth, behavior: 'smooth' }); }
  else { el.scrollTo({ left: 0, behavior: 'smooth' }); }
  setTimeout(updateIngredientMobileArrows, 400);
}
function updateIngredientMobileArrows() {
  var el = document.getElementById('ingredientImagesMobile');
  var wrap = el ? el.closest('.ingredient-mobile') : null;
  if (!wrap) return;
  var leftBtn = wrap.querySelector('.ingredient-scroll-left');
  var rightBtn = wrap.querySelector('.ingredient-scroll-right');
  if (!leftBtn || !rightBtn) return;
  leftBtn.style.display = el.scrollLeft > 10 ? 'flex' : 'none';
  rightBtn.style.display = (el.scrollLeft + el.clientWidth) < (el.scrollWidth - 10) ? 'flex' : 'none';
}
document.addEventListener('DOMContentLoaded', function () {
  var el = document.getElementById('ingredientImagesMobile');
  if (el) el.addEventListener('scroll', updateIngredientMobileArrows);
});

function scrollCapsules(dir) {
  var el = document.getElementById('capsuleGrid');
  if (!el) return;
  if (dir === 1) { el.scrollBy({ left: el.clientWidth * 0.9, behavior: 'smooth' }); }
  else { el.scrollBy({ left: -el.clientWidth * 0.9, behavior: 'smooth' }); }
  setTimeout(updateCapsuleArrows, 400);
}
function updateCapsuleArrows() {
  var el = document.getElementById('capsuleGrid');
  var leftBtn = document.querySelector('.capsule-scroll-left');
  var rightBtn = document.querySelector('.capsule-scroll-right');
  if (!el || !leftBtn || !rightBtn) return;
  leftBtn.style.display = el.scrollLeft > 10 ? 'flex' : 'none';
  rightBtn.style.display = (el.scrollLeft + el.clientWidth) < (el.scrollWidth - 10) ? 'flex' : 'none';
}
document.addEventListener('DOMContentLoaded', function () {
  var el = document.getElementById('capsuleGrid');
  if (el) el.addEventListener('scroll', updateCapsuleArrows);
});